import Company from "./Company";
import CompanyForm from "./CompanyForm";
import ExistingCompany from "./ExistingCompany";
import NewCompany from "./NewCompany";

export { CompanyForm, ExistingCompany, NewCompany };

export default Company;
